import React from 'react';
import { Main } from 'pages/main';
import { GlobalStyles } from 'GlobalStyles';

function App() {
  return (
    <div className='App'>
      <GlobalStyles />
      <Main />
    </div>
  );
}

export default App;
